/*
 *
 *  * *****************************************************************************
 *  *  Copyright (C) 2020 Testsigma Inc.
 *  *  All rights reserved.
 *  *  ****************************************************************************
 *
 */

import { custom, deserialize, object, serializable } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { UserPreferencePreference } from './user-preference-preference.model';

export class UserPreference extends Base implements Deserializable {
  @serializable
  public userId: number;
  @serializable(object(UserPreferencePreference))
  public preference: UserPreferencePreference;
  @serializable(
    custom(
      (v) => {
        return v;
      },
      (v) => {
        if (v.length == 0) return [];
        else return v;
      },
    ),
  )
  public closedMaintenances: number[];

  public isBulkActionOngoing: boolean;
  public bulkActionId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(UserPreference, input));
  }
}
